module.exports = __webpack_public_path__ + "static/media/o0.813ff3ea.svg";